var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoPlayer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "u5oaf32fra",
    d: "M14.519 4.148V2.074C14.519.934 13.585 0 12.444 0H2.074C.934 0 0 .933 0 2.074v8.296c0 1.141.933 2.074 2.074 2.074h10.37c1.141 0 2.075-.933 2.075-2.074V8.296l2.377 2.805c.654.654 1.77.191 1.77-.733V2.074c0-.924-1.116-1.386-1.77-.733L14.52 4.148z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bcm6ecwdzc",
    d: "M1.239.93l2.217 1.832c.288.238.33.664.091.952-.029.036-.061.068-.097.096L1.233 5.6c-.291.234-.717.189-.952-.102-.097-.12-.15-.27-.15-.425v-3.62c0-.374.303-.677.677-.677.157 0 .31.055.43.155z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    transform: "translate(-173 -1207) translate(105 119) translate(24 1080) translate(44 8)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#A5A5A5",
    transform: "translate(-173 -1207) translate(105 119) translate(24 1080) translate(44 8) translate(4 4)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-173 -1207) translate(105 119) translate(24 1080) translate(44 8) translate(4 4) translate(3.556 3.556) translate(3.111 6.222)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "33w6a2ch1b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#u5oaf32fra"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#323232",
    xlinkHref: "#u5oaf32fra"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    mask: "url(#33w6a2ch1b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H58.685V58.685H0z",
    transform: "translate(-5.502 -17.815)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-173 -1207) translate(105 119) translate(24 1080) translate(44 8) translate(4 4) translate(3.556 3.556) translate(9.202 9.497)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "gxry6ctf6d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bcm6ecwdzc"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#A5A5A5",
    xlinkHref: "#bcm6ecwdzc"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#A5A5A5",
    mask: "url(#gxry6ctf6d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H58.685V58.685H0z",
    transform: "translate(-9.76 -32.094)"
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPlayer);
export default __webpack_public_path__ + "static/media/videoPlayer.12bb6fa3043ea4e0fc6c06198d916460.svg";
export { ForwardRef as ReactComponent };